import { TagColors } from '@navi/web-ui/lib/primitives/Tag/types';

interface CodeMap {
  color: TagColors;
  label: string;
}
export const AgencyStatusMap = {
  ACTIVE: { color: 'green', label: 'Active' },
  INACTIVE: { color: 'orange', label: 'Inactive' },
  TERMINATED: { color: 'red', label: 'Terminated' }
} as { [key: string]: CodeMap };
